(function ($) {
    if ($('body').hasClass('post-type-archive-news-central')) {
        var currentNewsPage = 1;
        var newsAjax        = null;
        var ajaxTimeout     = null;

        var loadNews = function () {
            var template  = $('#js-news-item').html();
            var $loader   = $('.js-news-loader');
            var $list     = $('.js-news-list');
            var $loadMore = $('.js-news-next-page');

            Mustache.parse(template);

            var data = {
                page: currentNewsPage,
                nonce: rissb_var.nonces.get_news,
            };

            if (window.matchMedia('(max-width: 768px)').matches) {
                data.filters = $('.filter-mobile .js-news-filters :input').serialize();
            } else {
                data.filters = $('.filter-desktop .js-news-filters :input').serialize();
            }

            if (data.page == 1) {
                $loader.removeClass('d-none');
                $list.empty();
            }

            if (newsAjax) {
                newsAjax.abort();
            }

            newsAjax = $.post('/api/newsCentral', data, function (res) {
                var rendered   = Mustache.render(template, res.data);

                console.log(res.data);

                $loader.addClass('d-none');

                if (data.page == 1) {
                    $list.html(rendered);
                } else {
                    $list.append(rendered);
                }

                $(rendered).imagesLoaded(function() {
                    $.fn.matchHeight._apply('[data-mh="card-news"]');
                });

                $loadMore.closest('div').toggleClass('d-none', res.data.pagination.total <= res.data.pagination.current);
            }).always(function () {
                $loadMore.text($loadMore.data('text-original'));
            });
        };

        $(document).ready(function () {
            RISSB.fn.clearDropdownFilter(function () {
                currentNewsPage = 1;
                loadNews();
            });

            if ($('.js-news-list').length) {
                currentNewsPage = 1;
                loadNews();
            }

            $('.js-news-filters').find('.js-news-search').on('keyup input', function () {
                currentNewsPage = 1;

                clearTimeout(ajaxTimeout);
                ajaxTimeout = setTimeout(loadNews, 500);
            });

            $('.js-update-filter').on('click', function () {
                var $this = $(this);
                currentNewsPage = 1;

                RISSB.fn.updateQSParams('news_categories[]', $this.closest('.js-news-filters').find('input[name="news_categories[]"]:checked').map(function () {
                    return $(this).val();
                }).get(), true);

                loadNews();
                $this.closest('.dropdown-menu').removeClass('show');
            });

            $('.js-news-next-page').on('click', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentNewsPage = currentNewsPage + 1;

                $this.html('<i class="fas fa-spinner fa-spin fa-fw"></i> ' + $this.data('text-progress'));
                loadNews();
            });

            $('.js-news-list').on('click', '.js-filter-category', function (e) {
                e.preventDefault();

                var $this = $(this);

                $('.js-dropdown-filter-category').find('[type="checkbox"][name="news_categories[]"]').prop('checked', false);
                $('.js-dropdown-filter-category').find('[type="checkbox"][name="news_categories[]"][value="' + $this.data('id') + '"]').prop('checked', true).change();
                RISSB.fn.updateQSParams('news_categories[]', $this.data('id'));

                currentNewsPage = 1;

                loadNews();
            });

            $('.js-dropdown-sort').on('click', '.dropdown-item', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentNewsPage = 1;

                $('[name="orderby"]').val($this.data('orderby'));
                $('[name="order"]').val($this.data('order'));
                $('.js-order-type').text($this.text());

                loadNews();
            });

            $('.js-news-list').on('click', '.card-news-style-1, .card-news-style-2', function (e) {
                if ($(e.target).hasClass('js-filter-category')) {
                    return;
                }

                window.location = $(this).find('.card-news-read-more').attr('href');
            });

            if ($('body').hasClass('single-news-central')) {
                $('.is-sticky').stick_in_parent({
                    offset_top: $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0,
                });

                $content = $('.post-content');

                if ($content.find('iframe').length) {
                    var contentSelector = 'div.header, .layout, .one-col .column';

                    $content.find('iframe').each(function () {
                        var $iframe = $(this);

                        $iframe.removeAttr('width');
                        $iframe.css('width', '100%');
                    });
                }
            }
        });
    }
})(jQuery);
